import { CustomTooltipProps } from '../../types';
import { formatPowerProfileTooltip } from '../../utils';
import { Box, Typography } from '@mui/material';

/**
 * Custom tooltip component for PowerProfileChart that displays formatted power profile data
 * when hovering over chart elements. Uses Material-UI theming for consistent styling.
 *
 * @param props - Tooltip props from Recharts library
 * @param props.active - Whether the tooltip is currently active/visible
 * @param props.payload - Array of data points for the tooltip, contains chart data
 * @returns JSX element with formatted tooltip content or null if not active
 */
export const CustomTooltip = ({ active, payload }: CustomTooltipProps) => {
  if (active && payload && payload.length) {
    const data = payload[0];
    const tooltipData = formatPowerProfileTooltip(data.value || 0, '', { payload: data.payload });

    return (
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.background.paper,
          borderRadius: 4,
          p: 2,
        }}
      >
        {Object.entries(tooltipData).map(([key, value]) => (
          <Box key={key} sx={{ mb: 0.5, '&:last-child': { mb: 0 } }}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: (theme) => theme.palette.text.primary }}>
              {key}:
            </Typography>
            <Typography variant="body2" sx={{ color: (theme) => theme.palette.text.secondary, ml: 1 }}>
              {value}
            </Typography>
          </Box>
        ))}
      </Box>
    );
  }

  return null;
};
